import React  from 'react';
import Logs from '../src/log/Logs';
import Home from '../src/home/home';
import FormLogin from '../src/login/formLogin';
import Backup from '../src/backup/backup';
import { Switch, Route } from 'react-router-dom';
import {  Redirect } from 'react-router-dom';
import RealTime from '../src/realtime/realtimeComponent';
import CompanyVersion from '../src/companyVersions/companyVersions';
import ImportFile from '../src/ImportFile/ImportFile';
import User from './user/user';
import Audit from './Audit/audit';
import Version from './version/version';
import FingerPrint from './fingerPrint/fingerPrint';
import APIComponent from './APIComponent/api.jsx';
import ConstructionComponent from '../src/underConstruction/construction';
import Bulk from '../src/bulk/bulk';


export default class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            isWideEnough: false,
            dropdownOpen: false
        };

        this.logout = this.logout.bind(this);
    }

    logout() {
        this.setState({ isAutenticated: false });
        sessionStorage.setItem("user", '');
        sessionStorage.setItem("token", '');
        sessionStorage.setItem("rol", '');
        sessionStorage.setItem("email", '');
        sessionStorage.clear();
        
        window.validaterequestdata = undefined;

        return (<Redirect to={'/login'} />)
    }

    render() {
         if (window.validaterequestdata != undefined) {
             let currentvalues = btoa(sessionStorage.getItem("user")
             + sessionStorage.getItem("token")
             + sessionStorage.getItem("email")
             + sessionStorage.getItem("rol"));
             

            if(window.validaterequestdata != currentvalues){
                return this.logout();
            }
        }
        

        return (
            <div className="App">                       
                <Switch>
                    {/* <Route exact path='/' render={props =><FormLogin algo={this.algo} {...props} />} /> */}
                    <Route exact path='/' component={Home} />
                    <Route exact path='/login' component={FormLogin}/>
                    <Route exact path='/home' component={Home} />
                    <Route exact path='/log' component={Logs} />
                    <Route exact path='/device' component={RealTime} />
                    <Route exact path='/bulk' component={Bulk} />
                    <Route exact path='/companyVersion' component={CompanyVersion} />
                    <Route exact path='/Backup' component={Backup} />    
                    <Route exact path='/Import' component={ImportFile} /> 
                    <Route exact path='/user' component={User} />    
                    <Route exact path='/fingerPrint' component={FingerPrint} />  
                    <Route exact path='/audit' component={Audit} />    
                    <Route exact path='/version' component={Version} />      
                    <Route exact path='/api' component={APIComponent} />  
                    <Route exact path='/construction' component={ConstructionComponent} />   
                </Switch>       
            </div>
            );
        }    
}



// WEBPACK FOOTER //
// ./src/App.jsx